import {useDispatch} from "react-redux";
import * as ReactBootstrap from "react-bootstrap";
import React from "react";
import {Confirm, ICONS} from "../../../components";
import {showErrorToast, showSuccessToast} from "../../../state/toasts";
import {PartRequestService} from "../../../services";
import {PartRequest} from "../../../api";
import {AxiosResponse} from "axios";

export type PartRequestDeleteButtonProps={
    record:PartRequest
    onDelete?:(record:AxiosResponse)=>void
}

export const PartRequestDeleteButton = ({record, onDelete}:PartRequestDeleteButtonProps) => {
    const dispatch = useDispatch()
    let onReturnConfirm = function () {
        new PartRequestService(record.url)
            .makeDeleteRequest()
            .then((response) => {
                onDelete && onDelete(response)
                dispatch(
                    showSuccessToast('Success', 'Part request deleted successfully')
                )
            })
            .catch((errors) => {
                dispatch(showErrorToast('Error', errors.response.data))
            })
    }
    return (
        <>
            <Confirm
                onConfirm={onReturnConfirm}
                body="Are you sure you want to return this item?"
                confirmText="Confirm return item"
                confirmBSStyle="danger"
                title="Confirm return item"
            >
                <ReactBootstrap.Button
                    disabled={record.is_deleted}
                    variant="danger"
                >
                    {ICONS.DELETE}
                </ReactBootstrap.Button>
            </Confirm>
        </>
    )
}
